module.exports = __webpack_public_path__ + "img/073655.ced67ff1.png";